import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  pageContainer({ colors }) {
    return css`
      display: flex;
      flex-direction: column;
      align-items: baseline;
      background-color: ${colors.common.white};

      .hero-link__label {
        width: 100%;
      }

      .header_choice {
        display: flex;
        align-items: center;
        border-style: solid;
        border-bottom-color: ${colors.neutral[100]};
        border-bottom-width: 1px;
        width: 100%;
        min-height: 72px;
        margin-top: -16px;

        .logo-whitelabel {
          max-width: 120px;
          padding: 8px 0;
        }
      }
      .h1_choice {
        margin-top: 16px;
        font-size: 24px;
      }
      .h3_choice {
        color: ${colors.neutral[500]};
        font-size: 16px;
      }
      .icon_header_choice {
        padding: 16px 0;
      }

      .link-support-choice {
        text-align: center;
        max-width: 512px;
      }
      @media (max-width: 639px) {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        flex-wrap: wrap;
        .header_choice {
          display: flex;
          width: 100%;
          align-items: center;
        }
        .hero-link__label {
          width: 100%;
        }
        .logo-whitelabel {
          width: 115px;
        }
      }
    `
  },

  container: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    .titulos_layout {
      display: flex;
      flex-direction: column-reverse;
      margin-bottom: 24px;
    }
    .link_help_choice {
      margin-left: auto;
    }
    @media (min-width: 639px) {
      .titulos_layout {
        flex-direction: row;
        justify-content: space-between;
      }
    }
  `,
})

export default useStyles
